import { LoadingButtonProps } from '@mui/lab/LoadingButton/LoadingButton';
import { Grid, Typography } from '@mui/material';
import ActionButton from 'components/buttons';
import { FC, JSX } from 'react';
import DialogModal from './modal/dialog-modal';

interface IProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  text: JSX.Element | string;
  textNode?: JSX.Element;
  confirmText?: string;
  confirmBtnColor?: LoadingButtonProps['color'];
  cancelBtnColor?: LoadingButtonProps['color'];
  confirmBtnWidth?: string;
  isLoading?: boolean;
  updateTemplatesCheckbox?: React.ReactNode;
  maxWidth?: string;
  btnStyles?: {
    confirm?: any;
    cancel?: any;
  };
}

const ConfirmModal: FC<IProps> = ({
  open,
  onClose,
  title,
  text,
  onConfirm,
  isLoading,
  textNode,
  confirmText = 'Delete',
  maxWidth = '466px',
  confirmBtnColor = 'error',
  cancelBtnColor = 'primary',
  confirmBtnWidth,
  updateTemplatesCheckbox,
  btnStyles,
}) => {
  return (
    <DialogModal open={open} maxWidth={maxWidth} withCloseButton={false} handleClose={onClose}>
      <Grid container sx={{ mb: '10px' }} alignItems="center">
        <Typography
          component="span"
          sx={{
            fontSize: '24px',
            lineHeight: '20px',
            fontWeight: 400,
            color: '#23252F',
            fontFamily: 'Inter, sans-serif !important',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </Typography>
      </Grid>
      {textNode ? (
        textNode
      ) : (
        <Typography
          component="div"
          sx={{
            //margin: '30px 0',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 400,
            color: '#6E707A',
          }}
        >
          {text}
        </Typography>
      )}
      {updateTemplatesCheckbox && (
        <Grid item sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
          {updateTemplatesCheckbox}
        </Grid>
      )}
      <Grid container justifyContent="flex-end" sx={{ mt: '20px' }} gap={2}>
        <ActionButton
          style={btnStyles?.cancel}
          variant="secondary"
          onClick={onClose}
          label="Cancel"
        />
        <ActionButton
          style={btnStyles?.confirm}
          onClick={onConfirm}
          loading={isLoading}
          label={confirmText}
        />
      </Grid>
    </DialogModal>
  );
};

export default ConfirmModal;
